import rawTranslations from '../translations.json';

// @nike/i18n-react's convertTranslationsFromLocPlatform() infers the set of
// language buckets from translations[0]'s language fields only (lazy mode,
// which is not configurable via the provider). If a sparse (e.g. en-only)
// entry ever lands at index 0, every non-English bucket is dropped and the
// whole app renders `≪≪...≫≫` fallbacks. We defensively ensure entry[0]
// declares every language that appears anywhere in the file. Empty-string
// placeholders make the runtime's `.value || originalString` path fall
// back to the English primaryValue instead of wrapping in ≪≪ ≫≫.
const NON_LANG_FIELDS = new Set(['key', 'comment']);

const allLanguageTags = Array.from(
  new Set(
    rawTranslations.translations.flatMap((entry) =>
      Object.keys(entry).filter((k) => !NON_LANG_FIELDS.has(k)),
    ),
  ),
);

const firstEntryWithAllTags = { ...rawTranslations.translations[0] };
allLanguageTags.forEach((tag) => {
  if (!(tag in firstEntryWithAllTags)) {
    firstEntryWithAllTags[tag] = '';
  }
});

const updatedTranslations = {
  ...rawTranslations,
  translations: [firstEntryWithAllTags, ...rawTranslations.translations.slice(1)],
};

export const supportedLanguages = [
  {
    name: 'English (US)',
    tag: 'en',
  },
  {
    name: 'Arabic',
    tag: 'ar',
  },
  {
    name: 'Catalan',
    tag: 'ca',
  },
  {
    name: 'Czech',
    tag: 'cs',
  },
  {
    name: 'Danish',
    tag: 'da',
  },
  {
    name: 'German',
    tag: 'de',
  },
  {
    name: 'Greek',
    tag: 'el',
  },
  {
    name: 'English (United Kingdom)',
    tag: 'en-GB',
  },
  {
    name: 'English',
    tag: 'en-XA',
  },
  {
    name: 'Spanish (as used in Latin America and the Caribbean)',
    tag: 'es-419',
  },
  {
    name: 'Spanish (Argentina)',
    tag: 'es-AR',
  },
  {
    name: 'Spanish (Spain)',
    tag: 'es-ES',
  },
  {
    name: 'Spanish (Mexico)',
    tag: 'es-MX',
  },
  {
    name: 'French',
    tag: 'fr',
  },
  {
    name: 'Hebrew',
    tag: 'he',
  },
  {
    name: 'Hungarian',
    tag: 'hu',
  },
  {
    name: 'Indonesian',
    tag: 'id',
  },
  {
    name: 'Italian',
    tag: 'it',
  },
  {
    name: 'Japanese',
    tag: 'ja',
  },
  {
    name: 'Korean',
    tag: 'ko',
  },
  {
    name: 'Norwegian',
    tag: 'nb',
  },
  {
    name: 'Dutch',
    tag: 'nl',
  },
  {
    name: 'Polish',
    tag: 'pl',
  },
  {
    name: 'Portuguese (Brazilian)',
    tag: 'pt-BR',
  },
  {
    name: 'Portuguese (European)',
    tag: 'pt-PT',
  },
  {
    name: 'Russian',
    tag: 'ru',
  },
  {
    name: 'Swedish',
    tag: 'sv',
  },
  {
    name: 'Thai',
    tag: 'th',
  },
  {
    name: 'Turkish',
    tag: 'tr',
  },
  {
    name: 'Chinese (Simplified)',
    tag: 'zh-Hans',
  },
  {
    name: 'Chinese (Traditional)',
    tag: 'zh-Hant',
  },
];
export default updatedTranslations;
